// Remove the links that are not lowest level child items on the navigation bar

export const sanitizeNavigation = urlList => {
  // First we need to figure out how many child nodes does the nav item have. So we loop through the whole
  // array to get the max amount of `/` on a single element.
  let childNodeCount = 0;

  urlList.forEach(url => {
    const slashCountInUrl = (url.match(/\//g) || []).length; // Get the amount of '/' on a single url

    // If the amount of '/' is bigger than the node counter, override its value
    childNodeCount = slashCountInUrl > childNodeCount ? slashCountInUrl : slashCountInUrl;
  });

  // Once we have the amount of child nodes, we can figure out if each item is a lowest level child node.
  // If not, we remove it from the list
  urlList.forEach(url => {
    const slashCountInUrl = (url.match(/\//g) || []).length; // Get the item's amount of '/'

    // If the amount of '/' is different from the node count, find it and remove it.
    if (slashCountInUrl !== childNodeCount) {
      const index = urlList.indexOf(url);

      if (index > -1) {
        urlList.splice(index, 1);
      }
    }
  });
  return urlList;
};
